import { useEffect, useState } from "react";
import RightWrapper from "../../../Components/CommonComponents/ComponentWrapper";
import CustomTable from "../../../Components/CommonComponents/CustomTable";
import { SmallSwitchMenu } from "../../../Components/CommonComponents/SmallSwitchMenu";
import { useCheckRole, useGetLoggedInUser } from "../../../UtilityHookFunctions/LoggedInUser";
import { useNavigate } from "react-router-dom";
import TherapyModuleTabs from "./TherapyModuleTabs";
import TableActionButton from "../../../Components/CommonComponents/TableActionButton";
import { FiPlus } from "react-icons/fi";

const main_head = ["patientName", "therapy", "status", "duration", "bidPrice", "complete_date"];
const custom_head = ["Patient", "Therapy Requested", "Status", "Duration (Days)", "Agreed Price", "Completed On"];

const OtherModificationButton = ({ item }) => {
  const navigate = useNavigate();
  const checkrole = useCheckRole();
  return (
    <>
      {checkrole("maindoctor") && item?.status === "requested" && (
        <TableActionButton variant="primary" onClick={() => navigate(`/AlternativeTherapies/${item?._id}`)}>
          Open for Bidding
        </TableActionButton>
      )}
      {item?.status === "treating" && (
        <TableActionButton variant="primary" onClick={() => navigate(`/AlternativeTherapies/${item?._id}/update`)}>
          Update
        </TableActionButton>
      )}
      {item?.status === "done" && (
        <TableActionButton variant="primary" onClick={() => navigate(`/AlternativeTherapies/${item?._id}/update`)}>
          Check Result
        </TableActionButton>
      )}
      <TableActionButton onClick={() => navigate(`/Bids/${item?._id}`)}>View</TableActionButton>
    </>
  );
};

const DoctorMenu = { Requests: "requested", "On Bid": "bid", Treating: "treating", Completed: "done" };
const ConsultantMenu = { Treating: "treating", Completed: "done" };
const MENU_KEY = "alternative_therapies_menu";

const AlternativeTherapiesList = () => {
  const checkrole = useCheckRole();
  const user = useGetLoggedInUser();
  const navigate = useNavigate();
  const menu = checkrole("consultant") ? ConsultantMenu : DoctorMenu;
  const saved = localStorage.getItem(MENU_KEY);
  const [chosen, setselectedmenu] = useState(saved);
  const selectmenu = menu[chosen] ? chosen : Object.keys(menu)[0];

  useEffect(() => {
    localStorage.setItem(MENU_KEY, selectmenu);
  }, [selectmenu]);

  const queries = { search: true, status: menu[selectmenu] };
  if (checkrole("consultant")) queries.consultant = user?._id;

  return (
    <RightWrapper>
      <div className="px-2 py-4 md:px-4">
        <TherapyModuleTabs />
        <div className="flex flex-wrap items-center justify-between gap-3">
          <SmallSwitchMenu options={menu} selectmenu={selectmenu} setselectedmenu={setselectedmenu} />
          {checkrole("maindoctor") && (
            <button
              type="button"
              onClick={() => navigate("/AlternativeTherapies/new")}
              className="mb-4 inline-flex items-center gap-1.5 rounded-xl bg-sky-600 px-4 py-2 text-sm font-semibold text-white shadow-sm shadow-sky-600/30 transition hover:bg-sky-700"
            >
              <FiPlus className="h-4 w-4" />
              New Request
            </button>
          )}
        </div>
        <CustomTable
          tablekeys={main_head}
          customHead={custom_head}
          fetchUrl={`alternative_therapy/list?`}
          Queries={queries}
          DeleteUrl={null}
          View={null}
          OtherModificationButton={OtherModificationButton}
        />
      </div>
    </RightWrapper>
  );
};

export default AlternativeTherapiesList;
